module.exports = __webpack_public_path__ + "media/images/icons/outlined/up-34470a4b7576324adb32c7996c21657e.svg";